import {computed, ref, watch} from "vue";
import {useStore} from "vuex";

const useInstallation = () => {
  const store = useStore();
  const user = computed(() => store.getters['user/user']);
  const showVendastaModal = ref(false);

  const beginInstallation = (emit) => {
    window.mixpanel('Onsite Optimizer: Install Myself Click', {
      website_id: user.value?.active_website?.id,
    });

    if (user.value.organisation_customer_type === 'VENDASTA' && user.value.is_organisation_admin) {
      showVendastaModal.value = true;
      return;
    }

    emit('nextStep');
  };

  const assistedInstallation = (emit) => {
    window.mixpanel('Onsite Optimizer: Install For Me Click', {
      website_id: user.value?.active_website?.id,
    });

    emit('goToAssisted');
  };

  const showInstallForMeButton = computed(() => {
    const customerType = user.value.organisation_customer_type;

    if (!store.getters['onsiteEditorInstallation/canRequestInstall']) {
      return false;
    }

    if (!customerType || ['AGENCY', 'PARTNER'].includes(customerType)) {
      return user.value.is_organisation_admin;
    }

    if (['APPSUMO', 'PARTNER_CHILD'].includes(customerType)) {
      return false;
    }

    return true;
  });


  const requestedInstallation = computed(() => store.getters['user/requestedOptimiserInstallationForActiveWebsite']);
  const canBypassOptimiser = computed(() => store.getters['onsiteEditorInstallation/canBypassOptimiser']);
  const optimiserInstalled = computed(() => store.getters['onsiteEditorInstallation/optimiserInstalled']);

  // Ref instead of computed to allow for admins to close until page refresh
  const showAwaitingInstallationModal = ref(false);

  watch(requestedInstallation, () => {
      if (optimiserInstalled.value) {
        return;
      }

      if (requestedInstallation.value && !canBypassOptimiser.value) {
        showAwaitingInstallationModal.value = true;
        return;
      }

      showAwaitingInstallationModal.value = canBypassOptimiser.value ? false : requestedInstallation.value;
    },
    {immediate: true}
  );

  const isAdmin = computed(() => store.getters['user/isAdmin']);

  const disableContinue = computed(() => {
    if (isAdmin.value) {
      return false;
    }

    if (canBypassOptimiser.value) {
      return false;
    }

    return !optimiserInstalled.value;
  });

  return {
    showInstallForMeButton,
    assistedInstallation,
    beginInstallation,
    showAwaitingInstallationModal,
    showVendastaModal,
    disableContinue,
    optimiserInstalled,
  };
};

export default useInstallation;
